import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadAutocomplete } from 'Actions/interest';
import CustomAutocomplete from 'Common/CustomAutocomplete';

@connect(
    store => ({
        interestsFilter: store.interestsAutocomplete.filter,
        interestsData: store.interestsAutocomplete.data,
    }),
    dispatch => ({
        loadAutocomplete: filter => dispatch(loadAutocomplete(filter)),
    })
)
export default class InterestsAutocomplete extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        loadAutocomplete: PropTypes.func.isRequired,
        interestsFilter: PropTypes.object.isRequired,
        interestsData: PropTypes.array.isRequired,
        value: PropTypes.any,
    };

    state = {
        values: null
    };

    /**
     * @param nextProps
     */
    componentWillReceiveProps(nextProps) {
        const { value } = nextProps;
        if (this.state.values === null && Array.isArray(value)) {
            this.handleChange(value);
        }
    }

    /**
     * Load autocomplete options
     *
     * @param inputValue
     */
    handleInputChange = (inputValue) => {
        const { loadAutocomplete, interestsFilter } = this.props;
        const { values } = this.state;

        loadAutocomplete(
            interestsFilter.merge({
                where: {
                    or: [{ title: { like: `%${inputValue}%` } }, { id: { inq: values } } ],
                },
            })
        );
    };

    /**
     * @param values
     */
    handleChange = (values) => {
        this.setState({ values });
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { interestsData, ...autocompleteProps } = this.props;

        return (
            <CustomAutocomplete
                {...autocompleteProps}
                options={[
                    ...interestsData.map(item => ({
                        label: item.title,
                        value: item.id,
                    })),
                ]}
                customChange={this.handleChange}
                onInputChange={this.handleInputChange}
                isMulti
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Autocomplete/InterestsAutocomplete.jsx